// Resolve the order reference to link to from a ticket.
//
// Prefers the backend-extracted `order_id`. Falls back to parsing the subject /
// snippet for an Audio Trader Shopify order name (e.g. "AT-GB-5470") so tickets
// synced before the backend extractor learned that format still get a working
// order link without a re-sync or DB backfill.
export function ticketOrderRef(ticket) {
  if (!ticket) return null
  if (ticket.order_id) return String(ticket.order_id)
  const text = `${ticket.subject || ''} ${ticket.snippet || ''}`
  const match = text.match(/\b(AT-[A-Z]{2}-\d{3,})\b/i)
  return match ? match[1].toUpperCase() : null
}
